'use strict';

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'AE',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            succesText: '=',
            infoText: '='
        },
        template: [
            '<div>',
            '<button type="button" class="btn-xs btn-success" ng-show="toggle" ng-click="toggleButton(false)">{{succesText}}</button>',
            '<button type="button" class="btn-xs btn-info" ng-show="!toggle" ng-click="toggleButton(true)">{{infoText}}</button>',
            '</div>'
        ].join(''),

        link: function (scope, iElement, iAttrs, ngModel) {
            scope.toggle = false;
            scope.$watch(function () {
                return ngModel.$modelValue;
            }, function (modelValue) {
                scope.toggle = modelValue;
            });

            scope.toggleButton = function(toggle) {
                scope.toggle = toggle;
                ngModel.$setViewValue(toggle);
            }
        }
    };
};